import { BigNumber } from 'bignumber.js'

export const FEES_NUMERATOR = new BigNumber(process.env.REACT_APP_FEES_NUMERATOR)
export const FEES_DENOMINATOR = new BigNumber(process.env.REACT_APP_FEES_DENOMINATOR)
